import { render, staticRenderFns } from "./IspFaults.vue?vue&type=template&id=63c7af0c&scoped=true&"
import script from "./IspFaults.vue?vue&type=script&lang=js&"
export * from "./IspFaults.vue?vue&type=script&lang=js&"
import style0 from "./IspFaults.vue?vue&type=style&index=0&id=63c7af0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7af0c",
  null
  
)

export default component.exports